<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <confirm-box ref="confirm" :noConfirm="true"></confirm-box>
        <div class="row">
            <div class="d-none d-lg-block col-2"></div>
            <div class="col-12 col-lg-8">

                <h1>Student Upload</h1>
                <p>This page allows for uploading student information with a CSV file. These headings are required:
                    <span class="text-primary font-monospace">first_name</span>, <span class="text-primary font-monospace">last_name</span>, 
                    <span class="text-primary font-monospace">grad_year</span>, and <span class="text-primary font-monospace">number</span>.
                </p>

                <div class="row mt-4">

                    <div class="mb-3 col-12 col-md-4">
                        <label for="district-select" class="form-label">District</label>
                        <select class="form-select" v-model="selectedDistrict" id="district-select" required>
                            <option v-for="d in districts" :value="d.id">{{ d.name }}</option>
                        </select>
                    </div>

                    <div class="mb-3 col-12 col-md-8">
                        <label for="student-file" class="form-label">Student CSV File</label>
                        <div class="input-group">
                            <input class="form-control bg-white" type="file" id="student-file" accept=".csv" @change="fileAdded($event)">
                            <button type="button" class="btn btn-primary" @click="upload()" :disabled="file == null"><i class="fas fa-upload"></i>&nbsp;Upload</button>
                        </div>
                    </div>

                </div>

                <div class="list-group">
                    <admin-student-upload-result v-for="(st, index) in students"
                        :index="index + 1"
                        :student="st"
                        :key="`student-${index}`"
                    >
                    </admin-student-upload-result>
                </div>

                <div class="mt-4 d-flex">
                    <home-button></home-button>
                    <div class="flex-grow-1 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" @click="submit()" :disabled="session == null"><i class="fas fa-upload"></i>&nbsp;Submit</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import ConfirmBox from './ConfirmBox';
import HomeButton from './HomeButton.vue';
import AdminStudentUploadResult from './AdminStudentUploadResult.vue';

export default {
    /**
     * TODO: District should be marked as required
     * TODO: Student CSV File should be marked as required
     */

    components: { Loading, ConfirmBox, HomeButton, AdminStudentUploadResult },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/admin/users/allowed-districts')
            .then(response => {
                this.districts = response.data;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        fileAdded: function(ev) {
            this.file = ev.target.files[0];
        },

        noDistrict: function() {
            this.$refs.confirm.show({
                title: 'No District Selected',
                content: 'Please select a district to continue.',
                callback: () => {},
            });
        },

        upload: function() {
            if (this.selectedDistrict === null) {
                this.noDistrict();
                return;
            }

            this.isLoading = true;
            let fd = new FormData;
            fd.append('file', this.file);
            fd.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
            fd.append('district', this.selectedDistrict);

            axios
                .post('/api/admin/students/upload/parse', fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                })
                .then((response) => {
                    console.debug(response.data);
                    this.students = response.data.students;
                    this.session = response.data.session;
                })
                .catch((error) => {
                    try {
                        console.warn(error.response.data.message);
                        alert(error.response.data.message);
                    } catch (error) {
                        alert('An unknown error occured');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        submit: function() {
            this.isLoading = true;
            let data = {
                session: this.session
            };
            axios
                .post('/api/admin/students/upload/process', data)
                .then((response) => {
                    console.log(response.data)
                    this.students = [];
                    this.session = null;
                    this.file = null;
                    this.$refs.confirm.show({
                        title: 'Upload Successful',
                        content: `Successfully added ${response.data.length} students.`,
                        callback: () => {},
                    })
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    data() {
        return {
            districts: [],
            selectedDistrict: null,

            file: null,
            students: [],
            session: null,
            isLoading: false,
        }
    }
}
</script>